<template>
  <div class="membership-item">
    <section class="membership-item__title">
      <strong class="title">{{ data.name }}</strong>
	  <div class="controller">
	  <span @click="handleClickEdit">수정</span>
	  &nbsp;&nbsp;|&nbsp;&nbsp;
	  <span @click="handleClickDelete">삭제</span>
	  </div>
    </section>
    <div class="description">
      <span>{{ presentPrice(data.price) }}원</span>
      &nbsp;&nbsp;|&nbsp;&nbsp;
      <span>{{ presentDuration }}</span>
      &nbsp;&nbsp;|&nbsp;&nbsp;
      <span>{{ presentBalance }}</span>
    </div>
  </div>
</template>

<script>
import { DAY_UNIT } from "../../../constants";
import { numberWithCommas } from "@/utils/etc"
import { computedGetters } from "../../../utils/vuex-helper";

export default {
	name: "MembershipItem",
	props: ["data"],
	methods: {
		handleClickEdit() {
			this.$emit("modify", this.data);
		},
		handleClickDelete() {
			this.$emit("delete", this.data);
		},
		presentPrice(price) {
			if(price === 0){
				return "-";
			}
			return numberWithCommas(price);
		},
	},
	computed: {
		...computedGetters(["membershipSystem"]),
		presentBalance() {
			if (this.data.balance === -1) {
				return "무제한";
			}

			return numberWithCommas(this.data.balance + this.membershipSystem.short);
		},
		presentDuration() {
			let value = this.data.duration;

			if (value % DAY_UNIT.MONTH === 0) {
				return value / DAY_UNIT.MONTH + "개월";
			}

			return value / DAY_UNIT.DAY + "일";
		},
	},
};
</script>

<style lang="scss">
.membership-item {
	background-color: #f2f2f2;
	border-radius: 6px;
	border: 1px solid #d3d3d3;
	padding: 17px 13px 14px;
	position: relative;
	box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.19);
	margin-bottom: 10px;
    .membership-item__title{
		display: flex;
		.title {
			width: calc(100% - 66px);
			font-size: 16px;
			font-weight: 500;
			color: #4a4a4a;
			letter-spacing: -0.8px;
			line-height: 20px;
			margin-right: 6px;
			margin-bottom: 6px;
		}

		.controller {
			width: 60px;
			font-size: 12px;
			letter-spacing: -0.8px;
			color: #d3d3d3;

			& > span {
				color: #9b9b9b;

				&:hover {
					text-decoration: underline;
					cursor: pointer;
				}
			}
		}
	}

	.description {
		color: #d3d3d3;
		font-weight: 200;

		& > span {
			font-size: 14px;
			color: #4a4a4a;
			letter-spacing: -0.8px;
			line-height: 20px;
		}
	}

}
</style>
